<template>
  <div class="page-cont-box">
    <el-card class="task-nav title-task-nav">
      <span>{{$route.meta.parent}}</span>
      <span>/</span>
      <span>{{$route.meta.title}}</span>
    </el-card>
    <el-card class="body-task-nav task-details-cont">
      <el-row class="task-details-cont-row">
        <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="4">任务名称：{{pageData.task_name}}</el-col>
        <el-col
          :xs="8"
          :sm="8"
          :md="8"
          :lg="6"
          :xl="4"
        >任务类型：{{pageData.task_type=="transvideo"?"视频转码":pageData.task_type=="firstpic"?"视频抽取首帧":pageData.task_type=="cutvideo"?"视频截取片段":pageData.task_type=="cutpic"?"视频截取图片":pageData.task_type=="mp4tots"?"视频流化":pageData.task_type=="tstomp4"?"流化合成":""}}</el-col>
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">任务ID：{{pageData.task_id}}</el-col>
      </el-row>
      <el-row class="task-details-cont-row">
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" v-if="pageData.task_status=='正在运行'">
          任务状态：
          <el-progress :text-inside="true" :stroke-width="14" :percentage="pageData.task_progress"></el-progress>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" v-else>
          任务状态：
          <el-link
            :underline="false"
            :type="pageData.task_status=='正在运行'?'primary':pageData.task_status=='正在等待'?'info':pageData.task_status=='完成'?'success':pageData.task_status=='取消'?'warning':'danger'"
          >{{pageData.task_status}}</el-link>
        </el-col>
      </el-row>
      <el-row class="task-details-cont-row">
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">开始时间：{{pageData.task_time_start}}</el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">结束时间：{{pageData.task_time_end}}</el-col>
      </el-row>
      <el-row class="task-details-cont-row">
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">耗时：{{pageData.task_times}}</el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">创建时间：{{pageData.create_time}}</el-col>
      </el-row>
      <p class="item-title">源文件详情</p>
      <el-row class="task-details-cont-row">
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">{{pageData.file_input}}</el-col>
      </el-row>
      <el-form label-width="120px" label-position="left">
        <!-- 视频转码 -->
        <el-collapse-transition>
          <div class="cont-box" v-show="pageData.task_type=='transvideo'">
            <p class="item-title">高级参数设置</p>
            <el-form-item label="文件类型:">
              <el-select style="width:300px;" v-model="pageData.file_type">
                <el-option label="mp4" value="mp4"></el-option>
                <el-option label="flv" value="flv"></el-option>
                <el-option label="avi" value="avi"></el-option>
                <el-option label="mov" value="mov"></el-option>
              </el-select>
            </el-form-item>
            <p class="item-title">视频</p>
            <el-row type="flex">
              <el-col>
                <el-form-item label="视频格式:">
                  <el-select style="width:300px;" v-model="pageData.video_codec_id">
                    <el-option label="H264" value="H264"></el-option>
                    <el-option
                      label="H265"
                      value="H265"
                      v-show="pageData.file_type!='flv' && pageData.file_type!='avi'"
                    ></el-option>
                    <el-option label="MPEG4" value="MPEG4" v-show="pageData.file_type!='flv'"></el-option>
                    <el-option label="FLV1" value="FLV1" v-show="pageData.file_type!='mp4'"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="子类型:">
                  <el-select style="width:300px;" v-model="pageData.video_profile">
                    <el-option label="auto" value="auto"></el-option>
                    <el-option label="H264 Baseline" value="Baseline"></el-option>
                    <el-option label="H264 Main" value="Main"></el-option>
                    <el-option label="H264 High" value="High"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex">
              <el-col>
                <el-form-item label="分辨率:">
                  <el-select style="width:300px;" v-model="pageData.video_resolution">
                    <el-option label="1920x1080" value="1920*1080"></el-option>
                    <el-option label="1280x720" value="1280*720"></el-option>
                    <el-option label="960x540" value="960*540"></el-option>
                    <el-option label="720x576" value="720*576"></el-option>
                    <el-option label="720x480" value="720*480"></el-option>
                    <el-option label="640x480" value="640*480"></el-option>
                    <el-option label="640x360" value="640*360"></el-option>
                    <el-option label="自定义" value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="自定义:">
                  <el-input-number
                    :controls="false"
                    v-model="pageData.video_resolution_width"
                    controls-position="right"
                    style="width:100px;"
                    :disabled="pageData.video_resolution!=0"
                  ></el-input-number>
                  <span class="X-icon el-icon-close"></span>
                  <el-input-number
                    :controls="false"
                    v-model="pageData.video_resolution_height"
                    controls-position="right"
                    style="width:100px;"
                    :disabled="pageData.video_resolution!=0"
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex">
              <el-col>
                <el-form-item label="显示宽高比:">
                  <el-select style="width:300px;" v-model="pageData.video_xskgb">
                    <el-option label="4:3" value="4:3"></el-option>
                    <el-option label="16:9" value="16:9"></el-option>
                    <el-option label="同源" value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="码率:">
                  <el-select style="width:150px;" v-model="pageData.video_bit_rate_type">
                    <el-option label="VBR" value="VBR"></el-option>
                    <el-option label="CBR" value="CBR"></el-option>
                  </el-select>
                  <span class="X-icon"></span>
                  <el-input-number
                    :controls="false"
                    v-model="pageData.video_bit_rate"
                    controls-position="right"
                    style="width:90px;"
                    :min="0"
                    :max="50"
                    v-show="pageData.video_bit_rate_type=='CBR'"
                  ></el-input-number>
                  <el-input-number
                    :controls="false"
                    v-model="pageData.audio_crf"
                    controls-position="right"
                    style="width:90px;"
                    :min="0"
                    :max="50"
                    v-show="pageData.video_bit_rate_type=='VBR'"
                  ></el-input-number>
                  <span class="X-icon">{{pageData.video_bit_rate_type=='CBR'?'Mbps':'CRF'}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex">
              <el-col>
                <el-form-item label="帧率:">
                  <el-select style="width:300px;" v-model="pageData.video_fps">
                    <el-option label="25" value="25"></el-option>
                    <el-option label="30" value="30"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="GOP:">
                  <el-input-number
                    :controls="false"
                    v-model="pageData.video_gop"
                    controls-position="right"
                    style="width:100px;"
                  ></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex">
              <el-col>
                <el-form-item label="颜色格式:">
                  <el-select style="width:300px;" v-model="pageData.video_pix_fmt">
                    <el-option label="YUV420P" value="YUV420P"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col v-show="pageData.video_codec_id!='FLV1' && pageData.video_codec_id!='MPEG4'">
                <el-form-item label="预设:">
                  <el-select style="width:300px;" v-model="pageData.video_preset">
                    <el-option label="superfast" value="superfast"></el-option>
                    <el-option label="veryfast" value="veryfast"></el-option>
                    <el-option label="fast" value="fast"></el-option>
                    <el-option label="medium" value="medium"></el-option>
                    <el-option label="slow" value="slow"></el-option>
                    <el-option label="veryslow" value="veryslow"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex">
              <el-col v-show="pageData.video_codec_id!='FLV1' && pageData.video_codec_id!='MPEG4'">
                <el-form-item label="Tune:">
                  <el-select style="width:300px;" v-model="pageData.video_tune">
                    <el-option label="film" value="film"></el-option>
                    <el-option label="animation" value="animation"></el-option>
                    <el-option label="grain" value="grain"></el-option>
                    <el-option label="stillimage" value="stillimage"></el-option>
                    <el-option label="psnr" value="psnr"></el-option>
                    <el-option label="ssim" value="ssim"></el-option>
                    <el-option label="fastdecode" value="fastdecode"></el-option>
                    <el-option label="zerolatency" value="zerolatency"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <p class="item-title">音频</p>
            <el-row type="flex">
              <el-col>
                <el-form-item label="音频格式:">
                  <el-select style="width:300px;" v-model="pageData.audio_codec_id">
                    <el-option label="AAC" value="AAC"></el-option>
                    <el-option label="MP3" value="MP3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="声道数:">
                  <el-select style="width:300px;" v-model="pageData.audio_channels">
                    <el-option label="mono" value="mono"></el-option>
                    <el-option label="stereo" value="stereo"></el-option>
                    <el-option label="4channel" value="4channel"></el-option>
                    <el-option label="5.1channel" value="5.1channel"></el-option>
                    <el-option label="7.1chananel" value="7.1chananel"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex">
              <el-col>
                <el-form-item label="采样率:">
                  <el-select style="width:300px;" v-model="pageData.audio_sample_rate">
                    <el-option label="16000" value="16000"></el-option>
                    <el-option label="44100" value="44100"></el-option>
                    <el-option label="48000" value="48000"></el-option>
                    <el-option label="64000" value="64000"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="采样大小:">
                  <el-select style="width:300px;" v-model="pageData.audio_bit_rate">
                    <el-option label="32000" value="32000"></el-option>
                    <el-option label="64000" value="64000"></el-option>
                    <el-option label="128000" value="128000"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex">
              <el-col v-show="pageData.audio_codec_id=='AAC'">
                <el-form-item label="协议:">
                  <el-select style="width:300px;" v-model="pageData.audio_profile">
                    <el-option label="AAC_LOW" value="AAC_LOW"></el-option>
                    <el-option label="AAC_LD" value="AAC_LD"></el-option>
                    <el-option label="AAC_MAIN" value="AAC_MAIN"></el-option>
                    <el-option label="AAC_HE" value="AAC_HE"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col v-show="pageData.audio_codec_id=='MP3'">
                <el-form-item label="采样格式:">
                  <el-select style="width:300px;" v-model="pageData.audio_sample_fmt">
                    <el-option label="S16P" value="S16P"></el-option>
                    <el-option label="S32P" value="S32P"></el-option>
                    <el-option label="FLTP" value="FLTP"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-collapse-transition>
        <!-- firstpic -->
        <el-collapse-transition>
          <div class="cont-box" v-show="pageData.task_type=='firstpic'">
            <p class="item-title">高级参数设置</p>
            <el-form-item label="黑场检测百分比:">
              <el-select style="width:300px;" v-model="pageData.pic_pblack">
                <el-option label="85%" value="85"></el-option>
                <el-option label="90%" value="90"></el-option>
                <el-option label="95%" value="95"></el-option>
                <el-option label="100%" value="100"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-collapse-transition>
        <!-- cutvideo -->
        <el-collapse-transition>
          <div class="cont-box" v-show="pageData.task_type=='cutvideo'">
            <p class="item-title">高级参数设置</p>
            <el-form-item label="开始时间(秒):">
              <el-input-number
                v-model="pageData.video_starttime"
                controls-position="right"
                :min="1"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="结束时间(秒):">
              <el-input-number
                v-model="pageData.video_endtime"
                controls-position="right"
                :min="parseInt(pageData.video_starttime+1)"
              ></el-input-number>
            </el-form-item>
          </div>
        </el-collapse-transition>
        <!-- cutpic -->
        <el-collapse-transition>
          <div class="cont-box" v-show="pageData.task_type=='cutpic'">
            <p class="item-title">高级参数设置</p>
            <el-form-item label="指定时间(秒):">
              <el-input-number v-model="pageData.pic_time" controls-position="right" :min="1"></el-input-number>
            </el-form-item>
            <el-form-item label="截取数量:">
              <el-select style="width:300px;" v-model="pageData.pic_num">
                <el-option v-for="x in 5" :key="x" :label="x" :value="x"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-collapse-transition>
        <!-- mp4tots -->
        <el-collapse-transition>
          <div class="cont-box" v-show="pageData.task_type=='mp4tots'">
            <p class="item-title">高级参数设置</p>
            <el-form-item label="切片时间:">
              <el-select style="width:300px;" v-model="pageData.hls_time">
                <el-option label="10S" value="10"></el-option>
                <el-option label="20S" value="20"></el-option>
                <el-option label="30S" value="30"></el-option>
                <el-option label="40S" value="40"></el-option>
                <el-option label="50S" value="50"></el-option>
                <el-option label="60S" value="60"></el-option>
                <el-option label="120S" value="120"></el-option>
                <el-option label="180S" value="180"></el-option>
                <el-option label="300S" value="300"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="切片名称:">
              <el-input
                maxlength="15"
                show-word-limit
                type="text"
                placeholder="请输入切片名称"
                style="width:300px;"
                v-model="pageData.hls_name"
              ></el-input>
            </el-form-item>
          </div>
        </el-collapse-transition>
        <!-- 图片转码 -->
        <el-collapse-transition>
          <div class="cont-box" v-show="pageData.task_type=='transpic'">
            <p class="item-title">高级参数设置</p>
            <el-form-item label="文件类型:">
              <el-select style="width:300px;" v-model="pageData.file_type">
                <el-option label="jpg" value="jpg"></el-option>
                <el-option label="png" value="png"></el-option>
                <el-option label="gif" value="gif"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="图片宽高:">
              <el-input-number
                :controls="false"
                v-model="pageData.pic_width"
                controls-position="right"
                style="width:100px;"
                :min="0"
              ></el-input-number>
              <span class="X-icon el-icon-close"></span>
              <el-input-number
                :controls="false"
                v-model="pageData.pic_height"
                controls-position="right"
                style="width:100px;"
                :min="0"
              ></el-input-number>
            </el-form-item>
          </div>
        </el-collapse-transition>
        <!-- <el-collapse-transition>
          <div class="cont-box" v-show="pageData.task_type=='tstomp4'">
            <p class="item-title">高级参数设置</p>
          </div>
        </el-collapse-transition>-->
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      pageData: {
        task_name: "",
        task_type: this.$route.params.type,
        task_level: "1",
        task_uuid: "",
        file_type: "IOS MP4",
        video_codec_id: "H264",
        video_profile: "Baseline",
        video_preset: "medium",
        video_resolution: "640*360",
        video_resolution_width: 720,
        video_resolution_height: 576,
        video_tune: "zerolatency",
        video_xskgb: "4:3",
        video_lever: "auto",
        video_bit_rate_type: "VBR",
        video_bit_rate: 2000000,
        video_vbr_model: "qp",
        video_fps: 25,
        video_gop: 25,
        video_pix_fmt: "YUV420P",
        video_qmax: 50,
        video_qmin: 3,
        audio_codec_id: "AAC",
        audio_channels: "mono",
        audio_crf: 10,
        audio_sample_rate: 44100,
        audio_cyw: 16,
        pic_pblack: "85",
        video_starttime: "",
        video_endtime: "",
        pic_time: "",
        pic_num: "",
        hls_time: "",
        hls_name: "",
      },
    };
  },
  created() {
    this.getTaskDetailsFun();
  },
  methods: {
    ...mapActions("task", ["getTaskDetailsSto"]),
    getTaskDetailsFun() {
      let dataObj = this.getTaskDetailsSto({
        task_id: this.$route.params.id,
        task_type: this.$route.params.type,
      });
      dataObj.then(({ data }) => {
        if (data.status == 0) {
          this.pageData = { ...this.pageData, ...data.data };
        }
      });
    },
  },
};
</script>

<style>
.task-details-cont {
  padding-left: 50px;
  font-size: 14px;
  color: #666666;
}
.task-details-cont-row {
  margin-bottom: 30px;
}
</style>
<style scoped>
.item-title {
  color: #2d8cf0;
  font-size: 16px;
  padding-left: 10px;
  box-sizing: border-box;
  position: relative;
  height: 18px;
  line-height: 18px;
  margin-bottom: 22px;
  margin-top: 20px;
}
.item-title::before {
  content: "";
  width: 6px;
  height: 18px;
  border-radius: 3px;
  background-color: #2d8cf0;
  position: absolute;
  left: 0;
  top: 0;
}
</style>